import { LatLngTuple } from 'leaflet';

export const WCC_BOUNDARY_LAYER =
  'https://www.rbkc.gov.uk/arcgis/rest/services/WCC/FixMyStreetOpen/MapServer/4';

export const WCC_ARCGIS_MAP_SERVER_BASE_URL =
  'https://www.rbkc.gov.uk/arcgis/rest/services/WCC/FixMyStreetOpen/MapServer/';

export const GEOCODE_SERVER = import.meta.env.VITE_MAINSITE_GEOCODE_SERVER;

export const initialCenterWCC = [51.511422, -0.151843] as LatLngTuple;

export const LOCATION_ENDPOINT =
  import.meta.env.VITE_APIM_BASE_URL + '/locations/v1/find';
export const NEAREST_ENDPOINT =
  import.meta.env.VITE_APIM_BASE_URL + '/locations/v1/nearest';

export const WITHIN_BOUNDARY_ENDPOINT =
  import.meta.env.VITE_APIM_BASE_URL + '/gis-service/v1/within-boundary';

export const NEAREST_ASSET_ENDPOINT =
  import.meta.env.VITE_APIM_BASE_URL + '/gis-service/v1/find-nearest-asset';

export const apiKey = import.meta.env.VITE_APIM_API_KEY;
